import React from "react";
import { NavBarApp2 } from '../NavBarApp2'
import clients from '../../../data/app2-sinistre'
import Offer from './Offer'



function User({ data }) {
  return (
    <div className="card horizontal">
      <div className="card-image">
      </div>

      <div className="card-stacked">
        <div className="card-content">
          <div className="row">
            <div className="col s6">
              <h4 className="client"> {data.client.nom} {data.client.prenom}</h4>
              <p><i className="material-icons context-icons">directions_car</i> Véhicule
                : {data.vehicule.modele} {data.vehicule.immat}</p>
              <p> Age du véhicule : {data.vehicule.dateDeproduction} | Kilometrage
                : {data.vehicule.kilometrage} Kms</p>
              <p> {data.client.contact}</p>
              <blockquote>{data.texte}</blockquote>

              <table>
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Type Intervention</th>
                  <th>Services Aditionnels</th>
                </tr>
                </thead>
                <tbody>
                {data.sinistralite.map((intervention, index) =>
                  <tr key={index}>
                    <td>{intervention.date}</td>
                    <td><i className="material-icons context-icons">flash_on</i> {intervention.type}
                    </td>
                    <td> {intervention.ServicesAditionnel.map(service => service)}</td>
                  </tr>
                )}
                </tbody>
              </table>

            </div>
            <div className="col s6">
              {data.offres.map((offre, index) => <Offer key={index} offre={offre} texte={data.texte} pertinence={data.pertinence}/>)}

            </div>

          </div>
        </div>

      </div>
    </div>
  )
}


function Tab2App2() {


  // const list = clients.flatMap(client => {
  //     var offres = client.offres;
  //     var tot = offres.map(offre => ({...offre, ...client}));
  //     tot = tot.map(offre => {
  //         var latheoffre = refOffresJson.find(refOffre => refOffre.id === offre.id);
  //         return {...offre, ...latheoffre}
  //     });
  //     return tot
  //
  // }).sort((a, b) => b.pertinence - a.pertinence);

  return (
    <div>
      <NavBarApp2/>
      <div className="row">
        <div className="col s12">
          {clients.map((client, index) =>
            <User key={index} data={client}/>
          )
          }


        </div>
      </div>

    </div>
  )
}

export default Tab2App2